module.exports = __webpack_public_path__ + "img/5right-n-9df664a7.png";